export class TipoArticolo {
  codice: number;
  descrizione: string;
  testata: {
    codice: '05',
    descrizione: 'Testimoni'
  }
  
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/TipoArticolo.ts